module.exports = __webpack_public_path__ + "img/LAMINA GALVANIZADA.f61cece6.jpg";